import { useReadContract } from 'wagmi';

import { NFTMarket, getBuyPrice } from 'lib/abis/NFTMarket';
import { getContractAddress } from 'lib/addresses';

import { NftFilter } from 'types/Nft';

type Options = {
  enabled?: boolean;
};

export function useGetBuyPrice(variables: NftFilter, options: Options = {}) {
  return useReadContract({
    abi: NFTMarket,
    address: getContractAddress({
      chainId: variables.chainId,
      contractName: 'nftMarket',
    }),
    chainId: variables.chainId,
    functionName: 'getBuyPrice',
    args: [variables.contractAddress, BigInt(variables.tokenId)],
    query: {
      enabled: options.enabled ?? true,
      select: getBuyPrice.parseOutput,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  });
}
